import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2 pb-2 text-left" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "mt-2 pb-2 text-left" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "mt-2 pb-2 text-left" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = {
  key: 0,
  class: "mt-2 pb-2 text-left"
}
const _hoisted_15 = { class: "mt-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-medium text-gray-700 mb-2" }, "Selected:", -1)
const _hoisted_17 = { class: "list-disc pl-5 space-y-1 w-3/4" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "mt-2 pb-2 text-left" }
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = { class: "mt-1" }
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = { class: "mt-1" }
const _hoisted_27 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_28 = { class: "block truncate" }
const _hoisted_29 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "mt-2 pb-2 text-left" }
const _hoisted_32 = { class: "text-sm" }
const _hoisted_33 = { class: "mt-1" }
const _hoisted_34 = { class: "w-full" }
const _hoisted_35 = { class: "mt-1" }
const _hoisted_36 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_37 = { class: "block truncate" }
const _hoisted_38 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "mt-2 pb-2 text-left" }
const _hoisted_41 = { class: "text-sm" }
const _hoisted_42 = { class: "mt-1" }
const _hoisted_43 = { class: "w-full" }
const _hoisted_44 = { class: "mt-1 gap-1" }
const _hoisted_45 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_46 = { class: "block truncate" }
const _hoisted_47 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_48 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import {computed, onMounted, ref, watch} from "vue";
  import {
    Dialog,
    DialogTitle,
    DialogOverlay,
    TransitionRoot,
    TransitionChild,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
  } from "@headlessui/vue";
  import axios from "axios";
  import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentConfigEditDepositTieringDialog',
  props: { form: Object, show: Boolean, depositBankOption: Array },
  emits: ["submit", "update:show", "update:form", "close"],
  setup(__props, { emit }) {

const props = __props

  const store = useStore();

  const showSync = computed({
    get: () => props.show,
    set: (value) => emit("update:show", value),
  });

  onMounted(async () => {
  advanceFromOption.value = await paymentGateway();
  bankAdvanceFromOption.value = await fetchPageDepositBankProviderData();
});

const paymentGateway = async ()=>{
  let payload = {
    operatorId: store.state.selectedOperator?.operatorId,
  }
  try {
    const { data } = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-gateway/operator`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data.map((payment:any) => ({
      label: payment.paymentName,
      value: payment.id,
    }));
  } catch (error) {
    console.error("Error fetching payment gateways:", error);
    return [];
  }
};

let advanceFromOption = ref([]);
let bankAdvanceFromOption = ref([]);

const type = ref([{"label": "Payment Gateway", "value": "pgw"},{"label": "Account Bank", "value": "bank"}]);

const fetchPageDepositBankProviderData = async () => {
    const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    page:1,
    pageSize: 999,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-bank/pagination`;
  const { result: data } = await axios
  .post(url, payload)
  .then(({ data }) => data);
    return data.map((bank:any) => ({
      label: bank.name,
      value: bank.id,
    }))
  }


  const submitForm = () => {
    emit('submit', { selectedDepositPaymentOption: createSelectedOption.value, depositTiering: props.form })
    selectedOption.value = { label: "-Select-", value: null }
  }

  const selectedOption = ref({ label: "-Select-", value: null });
  const typeSelectedOption = ref({ label: "-Select-", value: null });
  const paymentSelectedOption = ref({ label: "-Select-", value: null });
  const bankSelectedOption = ref({ label: "-Select-", value: null });
  const createSelectedOption = ref<{ bank: any[]; pgw: any[] }>({ bank: [], pgw: [] });

  
  
  
  watch(
      () => props?.form?.OperatorDepositTieringsMappings,
      () => {
        if (!props?.form?.OperatorDepositTieringsMappings) return;
    const pgwMapping = props.form?.OperatorDepositTieringsMappings.filter((data: any) => {
      if(data.gatewayId) return data
    }).map((data: any) => ({
      label: data.OperatorPaymentGateway.Payment.name,
      value: data.gatewayId,
    }));
    const bankMapping = props.form?.OperatorDepositTieringsMappings.filter((data: any) => {
      if(data.depositId) return data
    }).map((data: any) => ({
      label: data.OperatorDeposit.name,
      value: data.depositId,
    }));
    createSelectedOption.value= {
      bank: bankMapping,
      pgw: pgwMapping,
    };

  })
  
  const paymentAdd = () => {
  const selected = paymentSelectedOption.value;

  if (!selected.value) {
    alert("กรุณาเลือก Payment Gateway ก่อน");
    return;
  }

  if(createSelectedOption.value.bank.length + createSelectedOption.value.pgw.length >= 3){
    alert("ไม่สามารถเพิ่มได้เกิน 3 รายการ");
    return;
  }

  const exists = createSelectedOption.value.pgw.find(
    (item) => item.value === selected.value
  );

  if (exists) {
    alert("รายการนี้ถูกเพิ่มแล้ว");
    return;
  }

  createSelectedOption.value.pgw.push({ ...selected });
};

const bankAdd = () => {
  const selected = bankSelectedOption.value;

  if (!selected.value) {
    alert("กรุณาเลือกธนาคารก่อน");
    return;
  }

  if(createSelectedOption.value.bank.length + createSelectedOption.value.pgw.length >= 3){
    alert("ไม่สามารถเพิ่มได้เกิน 3 รายการ");
    return;
  }

  const exists = createSelectedOption.value.bank.find(
    (item) => item.value === selected.value
  );

  if (exists) {
    alert("รายการนี้ถูกเพิ่มแล้ว");
    return;
  }

  createSelectedOption.value.bank.push({ ...selected });
};

const removeItem = (group: 'bank' | 'pgw', index: number) => {
  createSelectedOption.value[group].splice(index, 1);
};

const onlyNumber = (event: KeyboardEvent) => {
  const invalidChars = ["e", "E", "+", "-", "*", "/"];
  if (invalidChars.includes(event.key)) {
    event.preventDefault();
  }
};
  
return (_ctx: any,_cache: any) => {
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[9] || (_cache[9] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.form.id? _ctx.$t("messages.paymentDepositTieringConfig.PaymentConfigEditDepositTieringConfig"): _ctx.$t("messages.paymentDepositTieringConfig.PaymentConfigCreateDepositTieringConfig")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositTieringName")), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.name) = $event)),
                            name: "name",
                            id: "name",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, __props.form.name]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositTieringAccumulatedAmount")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.accumulatedAmount) = $event)),
                            name: "accumulatedAmount",
                            id: "accumulatedAmount",
                            onKeypress: onlyNumber,
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 544), [
                            [_vModelText, __props.form.accumulatedAmount]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositTieringAccumulatedDepositTransaction")), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.accumulatedDepositTransaction) = $event)),
                            name: "accumulatedDepositTransaction",
                            id: "accumulatedDepositTransaction",
                            onKeypress: onlyNumber,
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 544), [
                            [_vModelText, __props.form.accumulatedDepositTransaction]
                          ])
                        ])
                      ]),
                      (createSelectedOption.value.bank.length || createSelectedOption.value.pgw.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createElementVNode("ul", _hoisted_17, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createSelectedOption.value.bank, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: 'bank-' + index
                                  }, [
                                    _createTextVNode(" Account: " + _toDisplayString(item.label) + " ", 1),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (removeItem('bank', index)),
                                      class: "w-1/4 text-red-500 hover:text-red-700 text-xs"
                                    }, [
                                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.deleteSelected")), 1)
                                    ], 8, _hoisted_18)
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createSelectedOption.value.pgw, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: 'pgw-' + index
                                  }, [
                                    _createTextVNode(" PGW: " + _toDisplayString(item.label) + " ", 1),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (removeItem('pgw', index)),
                                      class: "w-1/4 text-red-500 hover:text-red-700 text-xs"
                                    }, [
                                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.deleteSelected")), 1)
                                    ], 8, _hoisted_20)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositType")), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_unref(Listbox), {
                              modelValue: typeSelectedOption.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((typeSelectedOption).value = $event))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_27, [
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(typeSelectedOption.value.label), 1),
                                        _createVNode(_component_SelectorIcon, {
                                          class: "w-5 h-5 text-gray-400 ml-auto",
                                          "aria-hidden": "true"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_Transition, {
                                    "leave-active-class": "transition duration-100 ease-in",
                                    "leave-from-class": "opacity-100",
                                    "leave-to-class": "opacity-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.value, (option, index) => {
                                            return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                              key: index,
                                              value: option,
                                              as: "template"
                                            }, {
                                              default: _withCtx(({ active, selected }) => [
                                                _createElementVNode("li", {
                                                  class: _normalizeClass([
                                    active
                                      ? 'text-amber-900 bg-amber-100'
                                      : 'text-gray-900',
                                    'cursor-default select-none relative py-2 pl-10 pr-4',
                                  ])
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass([
                                      selected ? 'font-medium' : 'font-normal',
                                      'block truncate',
                                    ])
                                                  }, _toDisplayString(option.label), 3),
                                                  selected
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                                        _createVNode(_component_CheckIcon, {
                                                          class: "w-5 h-5",
                                                          "aria-hidden": "true"
                                                        })
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 2)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      (typeSelectedOption.value.value == 'bank' )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositTypeBankAccount")), 1),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_unref(Listbox), {
                                    modelValue: bankSelectedOption.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((bankSelectedOption).value = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createVNode(_unref(ListboxButton), { class: "w-4/5 py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_36, [
                                              _createElementVNode("span", _hoisted_37, _toDisplayString(bankSelectedOption.value.label), 1),
                                              _createVNode(_component_SelectorIcon, {
                                                class: "w-5 h-5 text-gray-400 ml-auto",
                                                "aria-hidden": "true"
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_Transition, {
                                          "leave-active-class": "transition duration-100 ease-in",
                                          "leave-from-class": "opacity-100",
                                          "leave-to-class": "opacity-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bankAdvanceFromOption), (option, index) => {
                                                  return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                                    key: index,
                                                    value: option,
                                                    as: "template"
                                                  }, {
                                                    default: _withCtx(({ active, selected }) => [
                                                      _createElementVNode("li", {
                                                        class: _normalizeClass([
                                      active
                                        ? 'text-amber-900 bg-amber-100'
                                        : 'text-gray-900',
                                      'cursor-default select-none relative py-2 pl-10 pr-4',
                                    ])
                                                      }, [
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass([
                                        selected ? 'font-medium' : 'font-normal',
                                        'block truncate',
                                      ])
                                                        }, _toDisplayString(option.label), 3),
                                                        selected
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                                              _createVNode(_component_CheckIcon, {
                                                                class: "w-5 h-5",
                                                                "aria-hidden": "true"
                                                              })
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ], 2)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("button", {
                                          class: "mx-3 content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full px-3 py-1 rounded-md shadow-sm text-sm font-medium",
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (bankAdd()))
                                        }, "Add")
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (typeSelectedOption.value.value == 'pgw' )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.depositTypePaymentGateway")), 1),
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  _createVNode(_unref(Listbox), {
                                    modelValue: paymentSelectedOption.value,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((paymentSelectedOption).value = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_44, [
                                        _createVNode(_unref(ListboxButton), { class: "w-4/5 py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_45, [
                                              _createElementVNode("span", _hoisted_46, _toDisplayString(paymentSelectedOption.value.label), 1),
                                              _createVNode(_component_SelectorIcon, {
                                                class: "w-5 h-5 text-gray-400 ml-auto",
                                                "aria-hidden": "true"
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_Transition, {
                                          "leave-active-class": "transition duration-100 ease-in",
                                          "leave-from-class": "opacity-100",
                                          "leave-to-class": "opacity-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advanceFromOption), (option, index) => {
                                                  return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                                    key: index,
                                                    value: option,
                                                    as: "template"
                                                  }, {
                                                    default: _withCtx(({ active, selected }) => [
                                                      _createElementVNode("li", {
                                                        class: _normalizeClass([
                                      active
                                        ? 'text-amber-900 bg-amber-100'
                                        : 'text-gray-900',
                                      'cursor-default select-none relative py-2 pl-10 pr-4',
                                    ])
                                                      }, [
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass([
                                        selected ? 'font-medium' : 'font-normal',
                                        'block truncate',
                                      ])
                                                        }, _toDisplayString(option.label), 3),
                                                        selected
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                                              _createVNode(_component_CheckIcon, {
                                                                class: "w-5 h-5",
                                                                "aria-hidden": "true"
                                                              })
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ], 2)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("button", {
                                          class: "mx-3 content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full px-3 py-1 rounded-md shadow-sm text-sm font-medium",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (paymentAdd()))
                                        }, "Add")
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: submitForm,
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                    }, " Edit "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close'))),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                      ref: "cancelButtonRef"
                    }, " Cancel ", 512)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})